import { render } from "./ModalTab.vue?vue&type=template&id=4af372f4"
import script from "./ModalTab.vue?vue&type=script&lang=js"
export * from "./ModalTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__